var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.ids),function(id){return _c('div',{key:id,staticClass:"mb-3",staticStyle:{"page-break-after":"always"}},[_c('RecipeViewer',{attrs:{"id":id,"hide-options":"","mounted-mode":""}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }